//@flow
import withHandledAgentData from "../../../pages/Agents/agents/AgentCard/withHandledAgentData";
import AddAgentRow from "./AddAgentRow";

const ConnectedAddAgentRow = withHandledAgentData(AddAgentRow);
export default ConnectedAddAgentRow;